module.exports = __webpack_public_path__ + "img/0Q3C6212_Wood_MockedUp.87f15d2f.jpg";